import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-library',
  templateUrl: './edit-library.component.html',
  styleUrls: ['./edit-library.component.css']
})
export class EditLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
